/**
 * Idea tohoto classu (a podobnych) je built-in podpora pre externals kustomizacie...
 */
export var ChatActionHelper = {
    // detectOppositeParty: (messages: ChatMessageData[]) => ... custom logic ...
    detectOppositeParty: null,
};
